"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsert = exports.isUnique = exports.isNonEmpty = void 0;
const isNonEmpty = (value) => {
    return Array.isArray(value) && value.length > 0;
};
exports.isNonEmpty = isNonEmpty;
const isUnique = (value) => {
    return new Set(value).size === value.length;
};
exports.isUnique = isUnique;
const upsert = (xs, x, where, options = { prepend: false }) => {
    const index = xs.findIndex(where);
    return index !== -1
        ? xs.map((item, i) => (i === index ? x : item))
        : options.prepend ? [x, ...xs] : [...xs, x];
};
exports.upsert = upsert;
